export default (patterns = {}, msg = '', newDate) =>
  Object.keys(patterns)
    .reduce((acc, pattern) =>
      (new RegExp(pattern).test(msg) && patterns[pattern](newDate)) || acc, null)
